import './style.less';
import * as React from 'react';
import { Button } from 'telstra-ui/components/button/Button';
import SkeletonLoader from '@applications/order-tracker/components/skeleton-loader';
import { Spinner } from 'telstra-ui/components/spinner/spinner';

// tslint:disable-next-line: no-var-requires
const serverErrorLarge = require('../../../../images/Server-Error-Large.svg');

interface IPageLoadingIndicatorProps {
    error: boolean;
    screen?: object;
    loader?: string;
}

export class PageLoadingIndicator extends React.Component<IPageLoadingIndicatorProps> {
    constructor(props) {
        super(props);
    }

    public render() {
        const { error } = this.props;
        if (error) {
            return this.renderPageLoadError();
        }

        return this.renderPageLoadingIndicator();
    }

    private renderPageLoadError = () => {
        return this.renderPageCenter(
            <div>
                <div className="tc-st-page-load-indicator">
                    <img src={serverErrorLarge} />
                </div>
                <span className="tc-st-page-load-failed-text">
                    Failed to load the requested resource
                </span>
                <div className="tc-st-try-again">
                    <Button onClick={this.tryAgain}>Try again</Button>
                </div>
            </div>
        );
    }

    private renderPageLoadingIndicator = () => {
        return this.renderPageCenter(
            <div className="container tc-st-page-load-indicator">
                {this.props.loader === 'spinner' ? <Spinner size="tl-spinner-xlarge" /> :
                    <SkeletonLoader type="page" page={this.props.screen} />}
            </div>
        );
    }

    private renderPageCenter = (component) => {
        return (
            <div className="tc-st">
                <div id="tc-st-page-load-center">
                    <div className="tc-st-page-load-indicator-container">
                        {component}
                    </div>
                </div>
            </div>
        );
    }

    private tryAgain = () => {
        return window.location.reload();
    }
}
